module.exports = __webpack_public_path__ + "img/1f970.cc70785.svg";